define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    /////////////////////////////////// INITIALIZATION ///////////////////////////////////
    var QueueOrbView = ViewController.extend({
        ControllerName: "QueueOrbView",
        applicationType: 'QueueOrbView',

        initialize: function () {
            this.ringingCountView = this.getFirstElement(this.LPViewMap.ringingCount);
            this.queueOrbElement = this.getFirstElement(this.LPViewMap.queueOrb);
        },
        events: function () {
            this.bindViewEvent({view: this.queueOrbElement, callback: this.queueOrbClick, DOMEvent: "click"});

            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.connected, callback: this.toggleConnected});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.hasEngagements, callback: this.toggleHasEngagements});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.ringingCount, callback: this.updateRingingCount});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.tooltip, callback: this.setQueueOrbTooltip});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.acceptTitle, callback: this.setOrbTitle});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.maxChatsReached, callback: this.maxChatsUpdated});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.hotkey, callback: this.handleHotkeys});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.acceptingInProgress, callback: this.showAccepting});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.blink, callback: this.toggleBlink});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.timerEnabled, callback: this.enableOrDisableTimer});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.timerTimeLeft, callback: this.setQueueOrbTimer});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.respondToNextButtonVisible, callback: this.toggleNTAButtonVisibility});
            this.bindModel({modelPath: this.modelController.MODEL_UI_STATE_PATH + '.' + this.modelController.LPModelMap.respondToNextButtonEnabled, callback: this.toggleNTAConnected});
        },
        render: function () {
        }
    });

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////
    QueueOrbView.prototype.queueOrbStates = {
        empty: "",
        hasEngagements: "has_engagements",
        blink: "blink",
        timer: "show_timer",
        maxChats: "max_chats"
    };

    QueueOrbView.prototype.LPViewMap = {
        ringingCount: ".lpview_ringing_count",
        queueOrb: ".lpview_queue_orb",
        timerContainer: ".lpview_timer_container",
        timer: ".lpview_timer",
        acceptTitle: ".lpview_accept_title",
        RTN_button: ".lpview_RTN_button"
    };

    QueueOrbView.prototype.LPClassesMap = {
        RTN_enable: "RTN_enable",
        RTN_disable: "RTN_disable",
        hide: "hide",
        RTN_on: "RTN_on"
    };

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////
    /**
     * If the queue orb is clicked - accept chat
     */
    QueueOrbView.prototype.queueOrbClick = function () {
        this.modelController.acceptChat();
    };

    /**
     * Click the NTA (respond to next) button
     */
    QueueOrbView.prototype.showFirstInQueue = function () {
        this.modelController.showFirstInQueue();
    };

    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////
    /**
     * Binds/unbinds the button if according to if we're connected
     * @param data
     */
    QueueOrbView.prototype.toggleConnected = function(data) {
        var isConnected = data && data.newValue;
        var event = {view: this.queueOrbElement, callback: this.queueOrbClick, DOMEvent: "click"};
        if (isConnected) {
            this.bindViewEvent(event);
        } else {
            this.unbindViewEvent(event);
        }
    };

    /**
     * If there are engagements set the appropriate classes
     * @param data
     */
    QueueOrbView.prototype.toggleHasEngagements = function(data) {
        var canAccept = data && data.newValue;
        if (canAccept) {
            this.addClass(this.queueOrbElement, this.queueOrbStates.hasEngagements);
            this.removeClass(this.queueOrbElement, this.queueOrbStates.empty, false);
        } else {
            this.removeClass(this.queueOrbElement, this.queueOrbStates.hasEngagements);
        }
    };

    /**
     * Updates the ringing count
     * @param data
     */
    QueueOrbView.prototype.updateRingingCount = function (data) {
        var ringingCount = data && data.newValue;
        this.ringingCountView.innerHTML = ringingCount;
    };

    /**
     * Sets the tooltip
     * @param data
     */
    QueueOrbView.prototype.setQueueOrbTooltip = function (data) {
        var text;
        var key = data && data.newValue;
        if (key) {
            text = agentLEManager.translateLE(key);
        }
        if (this.queueOrbElement) {
            if (text) {
                this.queueOrbElement.title = text;
                // set a new attribute for alignment, because the tooltip spills out of the screen
                this.queueOrbElement.setAttribute("tooltip-align", "left");
            }
            else {
                this.queueOrbElement.removeAttribute("title");
                this.queueOrbElement.removeAttribute("tooltip-align");
                this.queueOrbElement.removeAttribute("tooltip-text");
            }
        }
    };

    /**
     * Sets the title of the queue orb
     * @param data
     */
    QueueOrbView.prototype.setOrbTitle = function (data) {
        var key = data && data.newValue;
        var newTitle = agentLEManager.translateLE(key);
        var orbTitle = this.getFirstElement(this.LPViewMap.acceptTitle);
        orbTitle.innerHTML = newTitle;
        orbTitle = null;
    };

    /**
     * Update if we've reached max chats
     * @param data
     */
    QueueOrbView.prototype.maxChatsUpdated = function (data) {
        var isMaxChatsReached = data && data.newValue;
        this.toggleClass(this.queueOrbElement, this.queueOrbStates.maxChats, isMaxChatsReached);
    };

    /**
     * Add/Remove the ACCEPT_NEXT_CHAT hotkey
     * @param data
     */
    QueueOrbView.prototype.handleHotkeys = function (data) {
        var operationName, key, tooltipProperty, shortcutType;
        if (data && data.newValue) {
            operationName = data.newValue.action;
            key = data.newValue.key;
            tooltipProperty = data.newValue.data;
        }
        if (key) {
            shortcutType = this.shortcutType[key];
        }
        if (tooltipProperty) {
            this[operationName](shortcutType, this.queueOrbClick, tooltipProperty);
        } else {
            this[operationName](shortcutType, this.queueOrbClick);
        }
    };

    /**
     * Shows that we are currently accepting a chat.
     * @param data
     */
    QueueOrbView.prototype.showAccepting = function (data) {
        var enabled = data && data.newValue;
        this.toggleClass(this.queueOrbElement, "loading", enabled);
    };

    /**
     * Set the css classes for blink
     * @param data
     */
    QueueOrbView.prototype.toggleBlink = function (data) {
        var enabled = data && data.newValue;
        if (enabled) {
            // The following line is designed to trigger the flow, so that the animation is indeed restarted.
            this.queueOrbElement.offsetWidth = this.queueOrbElement.offsetWidth;
            this.addClass(this.queueOrbElement, this.queueOrbStates.blink);
        } else {
            this.removeClass(this.queueOrbElement, this.queueOrbStates.blink);
        }
    };

    /**
     * Enables or disabled the timer, and creates the view if it is used for the first time
     * @param data
     */
    QueueOrbView.prototype.enableOrDisableTimer = function (data) {
        var enabled = data && data.newValue;
        if (enabled) {
            this.addClass(this.LPViewMap.queueOrb, this.queueOrbStates.timer);
            if (!this.timerView) {
                this.timerView = this.createView({
                    templateFile: "LP_timer_view.html",
                    target: this.LPViewMap.timerContainer
                });
            }
        } else {
            this.removeClass(this.LPViewMap.queueOrb, this.queueOrbStates.timer);
        }
    };

    /**
     * Sets the queue orb timer (nubmer of seconds left)
     * @param data
     */
    QueueOrbView.prototype.setQueueOrbTimer = function (data) {
        var timeLeft = data && data.newValue;
        if (typeof timeLeft === 'number') {
            var timerElement = this.getFirstElement(this.LPViewMap.timer, this.LPViewMap.timerContainer);
            if (timerElement) {
                timerElement.innerHTML = this.parseSecondsToTime(timeLeft);
            }
        }
    };

    /**
     * Sets if the NTA button is visible
     * @param data
     */
    QueueOrbView.prototype.toggleNTAButtonVisibility = function (data) {
        var isVisible = data && data.newValue;
        this.toggleClass(this.LPViewMap.RTN_button, this.LPClassesMap.hide, !isVisible);
        this.toggleClass(this.LPViewMap.queueOrb, this.LPClassesMap.RTN_on, isVisible);
    };

    /**
     *  When the connection status for LE changes, this function is called to determine the availability of the button.
     *  When "Active" - the button is shown. Otherwise, it will be disabled including the button functionality.
     * @param isConnected
     */
    QueueOrbView.prototype.toggleNTAConnected = function (data) {
        var isConnected = data && data.newValue;
        if (isConnected) {
            this.enableNTA();
        } else {
            this.disableNTA();
        }
    };

    /**
     * Register to NEXT_TO_TAKE_ACTION, set the button to enable and set the hot key
     * @param event
     */
    QueueOrbView.prototype.enableNTA = function (event) {
        this.registerShortcut(this.shortcutType.NEXT_TO_TAKE_ACTION, this.showFirstInQueue, {
            target: ".lpview_hotkey_tooltip_RTN",
            position: "top"
        });
        this.removeClass(this.LPViewMap.RTN_button, this.LPClassesMap.RTN_disable);
        this.addClass(this.LPViewMap.RTN_button, this.LPClassesMap.RTN_enable);
        this.bindViewEvent({selector: this.LPViewMap.RTN_button, callback: this.showFirstInQueue, DOMEvent: "click"});
    };

    /**
     * Unregister to NEXT_TO_TAKE_ACTION, set the button to disable and disable the hot key
     * @param event
     */
    QueueOrbView.prototype.disableNTA = function (event) {
        this.unregisterShortcut(this.shortcutType.NEXT_TO_TAKE_ACTION, this.showFirstInQueue);
        this.addClass(this.LPViewMap.RTN_button, this.LPClassesMap.RTN_disable);
        this.removeClass(this.LPViewMap.RTN_button, this.LPClassesMap.RTN_enable);
        this.unbindViewEvent({selector: this.LPViewMap.RTN_button, callback: this.showFirstInQueue, DOMEvent: "click"});
    };

    return QueueOrbView;

});
